module.exports = __webpack_public_path__ + "static/bhaal_2-mtg_clb-a2e829c5814df5d15f2ddc501e6cb90c.jpg";